<script>
  import Banner from "@/components/atoms/Banner";
  import OrderStatus from "@/components/atoms/OrderStatus";

  export default {
    components: { Banner, OrderStatus },
    mounted(){
      console.log(this.order)
    },
    computed: {
      order(){
        return this.$store.get('payment/orderFromHistory')
      },
    },
  }
</script>

<template>
  <Banner>
    <div id="order-confirmation">
      <div class="limiter">
        <template v-if="order">
          <div class="confirmed">
            <span class="fa fa-box-check"></span>Order Placed!
          </div>
          <OrderStatus :order="order"></OrderStatus>
        </template>
        <template v-else>
          <div class="no-order">
            Page Timed Out
          </div>
        </template>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#order-confirmation { 
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100%;
	.limiter { 
    flex-basis: 60rem;
    padding-top: 3rem;
    .confirmed{
      font-size: 1.5rem;
      margin-bottom: 2rem;
      .fa{
        color: $p;
        margin-right: 0.75rem;
      }
    }
	}
}
</style>